import { ref } from "vue";
import { useI18n } from 'vue-i18n'

//节流
export function useThrottle(func, delay) {
  const throttledFunc = ref(null);
  let lastCall = 0;

  throttledFunc.value = function (...args) {
    const now = new Date().getTime();
    if (now - lastCall >= delay) {
      lastCall = now;
      func.apply(this, args);
    }
  };

  return throttledFunc.value;
}
export function useBtnLoading() {
  const isLoading = ref(false); // 定义加载状态

  // 用于包装异步操作的方法
  const handleClick = async (action) => {
    isLoading.value = true; // 开始加载
    try {
      await action(); // 执行异步操作
    } finally {
      isLoading.value = false; // 结束加载
    }
  };

  return {
    isLoading, // 提供加载状态
    handleClick // 提供包装异步操作的方法
  };
}
//复制
export function handleCopy(){
  const { t } = useI18n();
  const copy=(text)=>{
    navigator.clipboard.writeText(text)
    .then(() => {
     ElMessage({ type: 'success', message: t('cart74') });
    })
    .catch(() => {
      ElMessage({ type: 'error', message: t('cart75') });
    });
  }
  return{
    copy
  }
}